import React from 'react';

const QuickActionsCard = ({ tasks, events, notes, user }) => {
  // Get recent activity
  const getRecentActivity = () => {
    const activities = [];

    // Add recent tasks
    tasks.slice(0, 3).forEach(task => {
      activities.push({
        type: 'task',
        icon: '✓',
        text: `<strong>${task.created_by_name || 'Someone'}</strong> created task "${task.title}"`,
        time: task.created_at || new Date().toISOString()
      });
    });

    // Add recent events
    events.slice(0, 2).forEach(event => {
      activities.push({
        type: 'event',
        icon: '★',
        text: `<strong>${event.created_by_name || 'Someone'}</strong> added event "${event.title}"`,
        time: event.created_at || new Date().toISOString()
      });
    });

    // Add recent notes
    notes.slice(0, 2).forEach(note => {
      activities.push({
        type: 'note',
        icon: '📝',
        text: `<strong>${note.created_by_name || 'Someone'}</strong> posted a note`,
        time: note.created_at || new Date().toISOString()
      });
    });

    // Sort by time and return top 5
    return activities
      .sort((a, b) => new Date(b.time) - new Date(a.time))
      .slice(0, 5);
  };

  const formatTimeAgo = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);

    if (seconds < 60) return 'Just now';
    if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
    if (seconds < 604800) return `${Math.floor(seconds / 86400)}d ago`;
    return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
  };

  const recentActivity = getRecentActivity();

  return (
    <div className="desk-card quick-actions-card">
      <div className="desk-card-header">
        <div className="desk-card-header-left">
          <div className="desk-card-icon quick-actions">
            <span>&#9889;</span>
          </div>
          <span className="desk-card-title">Quick Actions</span>
        </div>
      </div>
      <div className="desk-card-body">
        {/* Quick Action Buttons */}
        <div className="quick-actions-list">
          <button className="quick-action-btn" onClick={() => document.querySelector('.tasks-card .desk-card-action')?.click()}>
            <div className="quick-action-icon task">✓</div>
            <div className="quick-action-text">
              <span className="title">New Task</span>
              <span className="desc">Assign work to team</span>
            </div>
          </button>

          <button className="quick-action-btn" onClick={() => document.querySelector('.calendar-card .desk-card-action')?.click()}>
            <div className="quick-action-icon event">&#128197;</div>
            <div className="quick-action-text">
              <span className="title">Add Event</span>
              <span className="desc">Schedule a meeting</span>
            </div>
          </button>

          <button className="quick-action-btn" onClick={() => document.querySelector('.notes-card .desk-card-action')?.click()}>
            <div className="quick-action-icon note">&#128221;</div>
            <div className="quick-action-text">
              <span className="title">Create Note</span>
              <span className="desc">Share with team</span>
            </div>
          </button>

          <button className="quick-action-btn" onClick={() => document.querySelector('.messages-card .desk-card-action')?.click()}>
            <div className="quick-action-icon message">&#128172;</div>
            <div className="quick-action-text">
              <span className="title">New Message</span>
              <span className="desc">Start a conversation</span>
            </div>
          </button>
        </div>

        {/* Activity Feed */}
        <div className="activity-section">
          <div className="activity-title">Recent Activity</div>
          {recentActivity.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '1rem', color: '#a0aec0', fontSize: '0.8rem' }}>
              No recent activity
            </div>
          ) : (
            recentActivity.map((activity, index) => (
              <div key={index} className="activity-item">
                <div className="activity-icon">{activity.icon}</div>
                <div className="activity-content">
                  <div
                    className="activity-text"
                    dangerouslySetInnerHTML={{ __html: activity.text }}
                  />
                  <div className="activity-time">{formatTimeAgo(activity.time)}</div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default QuickActionsCard;
